export const Acknowledged = 'Acknowledged';
export const NotAcknowledged = 'Not Acknowledged';
export const Distributed = 'Distributed';
export const NotDistributed = 'Not Distributed';
export const Disabled = 'Disabled';
export const ACKDone = 'ACK Done';
export const ACKPending = 'ACK Pending';
export const Complete = 'Complete';
export const Pending = 'Pending';
export const Acknowledge = 'Acknowledge';
export const Distribute = 'Distribute';
export const DoNotDistribute = 'Do Not Distribute';

const SafetyLetterStatus = (status) => ({
	isAcknowledged: () => status === Acknowledged,
	isNotAcknowledged: () => status === NotAcknowledged,
	isDistributed: () => status === Distributed,
	isNotDistributed: () => status === NotDistributed,
	isDisabled: () => status === Disabled,
	isAckDone: () => status === ACKDone,
	isAckPending: () => status === ACKPending
});

export default SafetyLetterStatus;

export const safetyDecisionStatus = (decisionStatus) => ({
	isCompleted: () => decisionStatus === Complete,
	isPending: () => decisionStatus === Pending
});

export const CountrySummaryActionStatus = (action) => ({
	isAcknowledge: () => action === Acknowledge,
	isDistribute: () => action === Distribute,
	isNotDistribute: () => action === DoNotDistribute
});

export const getAckValidationObj = () => ({ valid: NotAcknowledged, Invalid: Acknowledged });
export const getDistDoNotDistValidationObj = () => ({ valid: Acknowledged, Invalid: NotAcknowledged });

export const getActionType = (action) =>
	action === Acknowledge
		? 'acknowledge'
		: action === Distribute ? 'distribute' : action === DoNotDistribute ? 'doNotDistribute' : '';
